import React from 'react'
import Aside from '../Aside/Aside'
import './ModulesComp.sass'
import {Switch, Route} from 'react-router-dom'
import FirstInputModule from '../Models/FirstInputModule/FirstInputModule'
import SecondInputModule from '../Models/SecondInputModule/SecondInputModule'
import RoadModule from '../Models/RoadModule/RoadModule'
import PolishingModuleStart from '../Models/PolishingModuleStart/PolishingModuleStart'
import PolishingModuleFinish from '../Models/PolishingModuleFinish/PolishingModuleFinish'
import ModeStart from '../Models/ModeStart/ModeStart'
import ModeFinish from '../Models/ModeFinish/ModeFinish'
import MethodModule from '../Models/MethodModule/MethodModule'
import Reply from "../Reply/Reply";

export default () =>
  <div className='modules'>
    <Aside/>
    <Switch>
      <Route exact path='/modules/input/blank'>
        <FirstInputModule />
      </Route>

      <Route path='/modules/input/details'>
        <SecondInputModule />
      </Route>

      <Route path='/modules/road'>
        <RoadModule/>
      </Route>

      <Route path='/modules/polishing'>

        <Route exact path='/modules/polishing/start'>

          <PolishingModuleStart/>

        </Route>

        <Route exact path='/modules/polishing/finish'>

          <PolishingModuleFinish/>

        </Route>

      </Route>

      <Route path='/modules/mode'>

        <Route path='/modules/mode/start'>

          <ModeStart/>

        </Route>

        <Route path='/modules/mode/finish'>

          <ModeFinish/>

        </Route>

      </Route>

      <Route path='/modules/reply'>
        <Reply/>
      </Route>

      <Route path='/modules/method'>
        <MethodModule/>
      </Route>
    </Switch>
  </div>
